"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tabs = _interopRequireDefault(require("../../molecules/tabs/Tabs"));

var _ButtonIcon = _interopRequireDefault(require("../../atoms/buttons/buttonIcon/ButtonIcon"));

var _AppTheme = _interopRequireDefault(require("../../../AppTheme"));

var _GridContainer = _interopRequireDefault(require("../../layouts/grid/GridContainer"));

var _GridItem = _interopRequireDefault(require("../../layouts/grid/GridItem"));

var _ListContainer = _interopRequireDefault(require("../../molecules/lists/ListContainer"));

var _ListItem = _interopRequireDefault(require("../../molecules/lists/ListItem"));

var _AvatarLetter = _interopRequireDefault(require("../../atoms/avatars/avatarLetter/AvatarLetter"));

var _LogoIcon = _interopRequireDefault(require("../../protons/icons/LogoIcon"));

var _SystemIcon = _interopRequireDefault(require("../../protons/icons/SystemIcon"));

var _OverflowMenuContainer = _interopRequireDefault(require("../../molecules/overflowMenu/OverflowMenuContainer"));

var _AppBar = _interopRequireDefault(require("../appBar/AppBar"));

var _BadgeText = _interopRequireDefault(require("../../atoms/badges/badgeText/BadgeText"));

var _Typography = _interopRequireDefault(require("../../protons/typography/Typography"));

var _Divider = _interopRequireDefault(require("../../atoms/dividers/Divider"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _core.makeStyles)({
  boxLeft: {
    flexGrow: 1,
    flexShrink: 1
  },
  boxRight: {
    flexGrow: 0,
    flexShrink: 0
  },
  backdrop: {
    zIndex: 3,
    backgroundColor: "#333333"
  },
  backdropNormalMenu: {
    zIndex: 3,
    maxWidth: function maxWidth(mobileScreen) {
      return mobileScreen ? "100%" : "336px";
    },
    position: function position(mobileScreen) {
      return mobileScreen ? 'fixed' : "initial";
    },
    flex: 1,
    backgroundColor: function backgroundColor(mobileScreen) {
      return !mobileScreen ? "transparent" : "#333333";
    }
  },
  closeSideMenu: {
    flex: 0 + '!important'
  },
  boxLevelOne: {
    boxShadow: "0 2px 8px ".concat((0, _core.fade)(_AppTheme.default.palette.common.black, 0.16))
  },
  boxLevelTwo: {
    boxShadow: "0 2px 8px ".concat((0, _core.fade)(_AppTheme.default.palette.common.black, 0.16))
  },
  boxScrollWrap: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    position: "relative"
  },
  boxScroll: {
    flexGrow: 1,
    overflowY: "auto",
    "& .MuiListItemText-root": {
      "& .MuiTypography-h3": {
        display: "inline",
        position: "relative",
        "&:before": {
          content: "''",
          position: "absolute",
          left: 0,
          width: 0,
          bottom: 0,
          height: 3,
          backgroundColor: function backgroundColor(normalMenu) {
            return normalMenu ? "transparent" : _AppTheme.default.palette.primary.main;
          },
          transition: _AppTheme.default.transitions.create(["width"], {
            duration: _AppTheme.default.transitions.duration.standard
          })
        },
        "&[class*=\"makeStyles-bold\"]": {
          "&:before": {
            width: "100%"
          }
        }
      }
    },
    marginTop: "45%"
  },
  avatarButton: {
    borderRadius: "100%"
  }
});

var WebBar = function WebBar(_ref) {
  var menu = _ref.menu,
      showLanguage = _ref.showLanguage,
      languageMenuItems = _ref.languageMenuItems,
      languageActive = _ref.languageActive,
      showAccount = _ref.showAccount,
      accountMenuItems = _ref.accountMenuItems,
      actionMenuItem = _ref.actionMenuItem,
      isLogin = _ref.isLogin,
      showSearch = _ref.showSearch,
      showCart = _ref.showCart,
      onClickLogo = _ref.onClickLogo,
      normalMenu = _ref.normalMenu;
  var mobileScreen = (0, _core.useMediaQuery)(_AppTheme.default.breakpoints.down('xs'));
  var styles = useStyles(mobileScreen, normalMenu);
  var showTabs = mobileScreen ? false : true;
  var accountMenuRef = (0, _react.useRef)();
  var languageMenuRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      openDrawerLvl1 = _useState2[0],
      setOpenDrawerLvl1 = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openDrawerLvl2 = _useState4[0],
      setOpenDrawerLvl2 = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openDrawerMobileLvl0 = _useState6[0],
      setOpenDrawerMobileLvl0 = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      openDrawerMobileLvl1 = _useState8[0],
      setOpenDrawerMobileLvl1 = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      openDrawerMobileLvl2 = _useState10[0],
      setOpenDrawerMobileLvl2 = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = _slicedToArray(_useState11, 2),
      openMenuLanguages = _useState12[0],
      setOpenMenuLanguages = _useState12[1];

  var _useState13 = (0, _react.useState)(null),
      _useState14 = _slicedToArray(_useState13, 2),
      openMenuAccount = _useState14[0],
      setOpenMenuAccount = _useState14[1];

  var _useState15 = (0, _react.useState)(-1),
      _useState16 = _slicedToArray(_useState15, 2),
      activeTab = _useState16[0],
      setActiveTab = _useState16[1];

  var _useState17 = (0, _react.useState)(-1),
      _useState18 = _slicedToArray(_useState17, 2),
      activeMenu = _useState18[0],
      setActiveMenu = _useState18[1];

  var tabs = menu.map(function (item) {
    return item.label;
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AppBar.default, {
    drawerIsOpen: openDrawerLvl1 || openDrawerMobileLvl0,
    position: normalMenu ? 'fixed' : 'sticky'
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    alignItems: "center",
    className: styles.boxLeft
  }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, {
    wrap: "nowrap",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_core.ButtonBase, {
    onClick: function onClick() {
      setActiveTab(-1);
      setActiveMenu(-1);
      setOpenDrawerLvl1(false);
      setOpenDrawerMobileLvl0(false);
      if (onClickLogo) onClickLogo();
    }
  }, /*#__PURE__*/_react.default.createElement(_LogoIcon.default, {
    type: "speachmark",
    color: "red",
    width: 48,
    height: 48
  }))), /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: true
  }, menu.length && showTabs ? /*#__PURE__*/_react.default.createElement(_Tabs.default, {
    tabs: tabs,
    value: activeTab >= 0 && activeTab,
    action: function action(index) {
      if (menu[index].children.length) {
        setOpenDrawerLvl1(true);
        setOpenDrawerLvl2(false);
        setActiveTab(index);
        setActiveMenu(-1);
      } else if (menu[index].url !== undefined) {
        window.open(menu[index].url, "_self");
      } else if (menu[index].pageId !== undefined) {
        window.open(menu[index].pageId, "_self");
      } else {
        if (actionMenuItem) actionMenuItem(menu[index]);
      }
    }
  }) : /*#__PURE__*/_react.default.createElement(_Tabs.default, {
    tabs: ["Menu"],
    asMenu: true,
    value: openDrawerMobileLvl0 && 0,
    action: function action() {
      setOpenDrawerMobileLvl0(true);
      setOpenDrawerMobileLvl1(false);
      setOpenDrawerMobileLvl2(false);
      setActiveMenu(-1);
    }
  })))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: styles.boxRight
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1,
    alignItems: "center"
  }, showCart && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_ButtonIcon.default, {
    action: function action() {},
    size: "large",
    variant: "tertiary",
    rounded: true,
    icon: "ic_shopping__checkout"
  })), showSearch && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_ButtonIcon.default, {
    action: function action() {},
    size: "large",
    variant: "tertiary",
    rounded: true,
    icon: "ic_search"
  })), showLanguage && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_core.ButtonBase, {
    onClick: function onClick(event) {
      return setOpenMenuLanguages(event.currentTarget);
    }
  }, /*#__PURE__*/_react.default.createElement(_BadgeText.default, {
    text: languageActive,
    color: "critical",
    size: "small"
  })), /*#__PURE__*/_react.default.createElement(_OverflowMenuContainer.default, {
    ref: languageMenuRef,
    anchorEl: openMenuLanguages,
    setAnchorEl: setOpenMenuLanguages,
    menuItems: languageMenuItems
  })), showAccount && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: "auto"
  }, isLogin ? /*#__PURE__*/_react.default.createElement(_core.ButtonBase, {
    onClick: function onClick(event) {
      return setOpenMenuAccount(event.currentTarget);
    },
    className: styles.avatarButton
  }, /*#__PURE__*/_react.default.createElement(_AvatarLetter.default, {
    letter: "VF",
    size: "xsmall"
  })) : /*#__PURE__*/_react.default.createElement(_ButtonIcon.default, {
    size: "large",
    variant: "tertiary",
    rounded: true,
    icon: "ic_admin",
    action: function action(event) {
      return setOpenMenuAccount(event.currentTarget);
    }
  }), /*#__PURE__*/_react.default.createElement(_OverflowMenuContainer.default, {
    ref: accountMenuRef,
    anchorEl: openMenuAccount,
    setAnchorEl: setOpenMenuAccount,
    menuItems: accountMenuItems
  }))))), /*#__PURE__*/_react.default.createElement(_core.Backdrop, {
    open: openDrawerLvl1 || openDrawerMobileLvl0,
    className: " ".concat(!normalMenu ? styles.backdrop : styles.backdropNormalMenu, " \n         ").concat(normalMenu && !(openDrawerLvl1 || openDrawerMobileLvl0) ? styles.closeSideMenu : "")
  }, /*#__PURE__*/_react.default.createElement(_core.Slide, {
    direction: "right",
    in: openDrawerLvl1
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    pt: 9,
    position: "fixed",
    width: _AppTheme.default.spacing(42),
    left: 0,
    top: 0,
    bottom: 0,
    bgcolor: "white",
    zIndex: 2,
    boxShadow: "0 2px 8px ".concat((0, _core.fade)(_AppTheme.default.palette.common.black, 0.16))
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    pt: 7.5,
    className: styles.boxScrollWrap
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    py: 2,
    className: styles.boxScroll
  }, activeTab > -1 && menu[activeTab].children.length && /*#__PURE__*/_react.default.createElement(_ListContainer.default, {
    className: styles.listContainer
  }, menu[activeTab].children.map(function (item, index) {
    if (item.children.length) {
      return /*#__PURE__*/_react.default.createElement(_ListItem.default, _extends({
        primary: item.label,
        heading: true,
        selected: index === activeMenu,
        startAdornment: item.icon && /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
          icon: item.icon
        })
      }, normalMenu && item.pageId ? {
        to: item.pageId,
        component: _reactRouterDom.Link
      } : {}, {
        action: function action() {
          setActiveMenu(index);
          setOpenDrawerLvl2(true);
        }
      }));
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ListItem.default, _extends({
        primary: item.label,
        selected: index === activeMenu,
        endAdornment: /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
          color: "red",
          icon: "ic_chevron__right",
          size: "xLarge"
        })
      }, normalMenu && item.pageId ? {
        to: item.pageId,
        component: _reactRouterDom.Link
      } : {}, {
        action: function action() {
          setActiveTab(-1);
          setActiveMenu(-1);
          setOpenDrawerLvl1(false);

          if (item.url) {
            window.open(item.url, "_self");
          } else if (actionMenuItem) {
            actionMenuItem(item);
          }
        },
        align: "center"
      })), /*#__PURE__*/_react.default.createElement(_Divider.default, {
        color: "greyTwo"
      }));
    }
  }))), (mobileScreen || !normalMenu) && /*#__PURE__*/_react.default.createElement(_core.Fade, {
    in: activeMenu < 0,
    addEndListener: function addEndListener() {}
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    p: 1,
    position: "absolute",
    top: 0,
    right: -60
  }, /*#__PURE__*/_react.default.createElement(_ButtonIcon.default, {
    rounded: true,
    variant: "transparentWhite",
    size: "large",
    icon: "ic_close",
    action: function action() {
      setActiveTab(-1);
      setActiveMenu(-1);
      setOpenDrawerLvl1(false);
    }
  })))))), /*#__PURE__*/_react.default.createElement(_core.Slide, {
    direction: "right",
    in: openDrawerLvl2
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    pt: 9,
    position: "fixed",
    width: _AppTheme.default.spacing(42),
    left: _AppTheme.default.spacing(42),
    top: 0,
    bottom: 0,
    bgcolor: "#F4F4F4",
    zIndex: 2,
    boxShadow: "0 2px 8px ".concat((0, _core.fade)(_AppTheme.default.palette.common.black, 0.16))
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    pt: 0,
    className: styles.boxScrollWrap
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    p: 1
  }, /*#__PURE__*/_react.default.createElement(_ButtonIcon.default, {
    rounded: true,
    variant: "transparentGrey",
    size: "large",
    icon: "ic_arrow__left",
    action: function action() {
      setActiveMenu(-1);
      setOpenDrawerLvl2(false);
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    py: 2,
    className: styles.boxScroll
  }, activeMenu > -1 && menu[activeTab].children[activeMenu].children.length && /*#__PURE__*/_react.default.createElement(_ListContainer.default, {
    className: styles.listContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    pl: 2.5,
    pb: 3,
    pt: 0
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    regular: true,
    variant: "h5",
    color: "VfRed",
    text: "See all"
  })), menu[activeTab].children[activeMenu].children.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ListItem.default, _extends({
      primary: item.label,
      align: "center",
      endAdornment: /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
        color: "red",
        icon: "ic_chevron__right",
        size: "xLarge"
      })
    }, normalMenu && item.pageId ? {
      to: item.pageId,
      component: _reactRouterDom.Link
    } : {}, {
      action: function action() {
        setActiveTab(-1);
        setActiveMenu(-1);
        setOpenDrawerLvl1(false);
        setOpenDrawerLvl2(false);

        if (item.url) {
          window.open(item.url, "_self");
        } else if (actionMenuItem) {
          actionMenuItem(item);
        }
      }
    })), /*#__PURE__*/_react.default.createElement(_Divider.default, {
      color: "greyTwo"
    }));
  }))), (mobileScreen || !normalMenu) && /*#__PURE__*/_react.default.createElement(_core.Fade, {
    in: activeMenu >= 0,
    addEndListener: function addEndListener() {}
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    p: 1,
    position: "absolute",
    top: 0,
    right: -60
  }, /*#__PURE__*/_react.default.createElement(_ButtonIcon.default, {
    rounded: true,
    variant: "transparentWhite",
    size: "large",
    icon: "ic_close",
    action: function action() {
      setActiveTab(-1);
      setActiveMenu(-1);
      setOpenDrawerLvl1(false);
      setOpenDrawerLvl2(false);
    }
  })))))), /*#__PURE__*/_react.default.createElement(_core.Slide, {
    direction: "right",
    in: openDrawerMobileLvl0
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    pt: 9,
    position: "fixed",
    width: _AppTheme.default.spacing(42),
    left: 0,
    top: 0,
    bottom: 0,
    bgcolor: "white",
    zIndex: 2,
    boxShadow: "0 2px 8px ".concat((0, _core.fade)(_AppTheme.default.palette.common.black, 0.16))
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    pt: 7.5,
    className: styles.boxScrollWrap
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    py: 2,
    className: styles.boxScroll
  }, menu.length && /*#__PURE__*/_react.default.createElement(_ListContainer.default, {
    className: styles.listContainer
  }, menu.map(function (item, index) {
    if (item.children.length) {
      return /*#__PURE__*/_react.default.createElement(_ListItem.default, _extends({
        primary: item.label,
        heading: true
      }, normalMenu && item.pageId ? {
        to: item.pageId,
        component: _reactRouterDom.Link
      } : {}, {
        startAdornment: item.icon && /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
          icon: item.icon
        }),
        action: function action() {
          setActiveTab(index);
          setOpenDrawerMobileLvl1(true);
        }
      }));
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ListItem.default, _extends({
        primary: item.label,
        selected: index === activeMenu,
        endAdornment: /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
          color: "red",
          icon: "ic_chevron__right",
          size: "xLarge"
        })
      }, normalMenu && item.pageId ? {
        to: item.pageId,
        component: _reactRouterDom.Link
      } : {}, {
        action: function action() {
          setActiveTab(-1);
          setActiveMenu(-1);
          setOpenDrawerMobileLvl0(false);

          if (item.url) {
            window.open(item.url, "_self");
          } else if (actionMenuItem) {
            actionMenuItem(item);
          }
        },
        align: "center"
      })), /*#__PURE__*/_react.default.createElement(_Divider.default, {
        color: "greyTwo"
      }));
    }
  }))), (mobileScreen || !normalMenu) && /*#__PURE__*/_react.default.createElement(_core.Fade, {
    in: activeMenu < 0,
    addEndListener: function addEndListener() {}
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    p: 1,
    position: "absolute",
    top: 0,
    right: -60
  }, /*#__PURE__*/_react.default.createElement(_ButtonIcon.default, {
    rounded: true,
    variant: "transparentWhite",
    size: "large",
    icon: "ic_close",
    action: function action() {
      setActiveTab(-1);
      setActiveMenu(-1);
      setOpenDrawerMobileLvl0(false);
    }
  })))))), /*#__PURE__*/_react.default.createElement(_core.Slide, {
    direction: "right",
    in: openDrawerMobileLvl1
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    pt: 9,
    position: "fixed",
    width: _AppTheme.default.spacing(42),
    left: mobileScreen ? 0 : _AppTheme.default.spacing(42),
    top: 0,
    bottom: 0,
    bgcolor: "white",
    zIndex: 2,
    boxShadow: "0 2px 8px ".concat((0, _core.fade)(_AppTheme.default.palette.common.black, 0.16))
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    pt: 0,
    className: styles.boxScrollWrap
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Box, {
    p: 1
  }, /*#__PURE__*/_react.default.createElement(_ButtonIcon.default, {
    rounded: true,
    variant: "transparentGrey",
    size: "large",
    icon: "ic_arrow__left",
    action: function action() {
      setActiveTab(-1);
      setOpenDrawerMobileLvl1(false);
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    p: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body",
    text: activeTab > -1 ? menu[activeTab].label : ""
  }))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    py: 2,
    className: styles.boxScroll
  }, activeTab > -1 && menu[activeTab].children.length && /*#__PURE__*/_react.default.createElement(_ListContainer.default, {
    className: styles.listContainer
  }, menu[activeTab].children.map(function (item, index) {
    if (item.children.length) {
      return /*#__PURE__*/_react.default.createElement(_ListItem.default, _extends({
        primary: item.label,
        heading: true
      }, normalMenu && item.pageId ? {
        to: item.pageId,
        component: _reactRouterDom.Link
      } : {}, {
        action: function action() {
          setActiveMenu(index);
          setOpenDrawerMobileLvl2(true);
        }
      }));
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ListItem.default, _extends({
        primary: item.label,
        selected: index === activeMenu,
        align: "center"
      }, normalMenu && item.pageId ? {
        to: item.pageId,
        component: _reactRouterDom.Link
      } : {}, {
        endAdornment: /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
          color: "red",
          icon: "ic_chevron__right",
          size: "xLarge"
        }),
        action: function action() {
          setActiveTab(-1);
          setActiveMenu(-1);
          setOpenDrawerMobileLvl0(false);
          setOpenDrawerMobileLvl1(false);

          if (item.url) {
            window.open(item.url, "_self");
          } else if (actionMenuItem) {
            actionMenuItem(item);
          }
        }
      })), /*#__PURE__*/_react.default.createElement(_Divider.default, {
        color: "greyTwo"
      }));
    }
  }))), (mobileScreen || !normalMenu) && /*#__PURE__*/_react.default.createElement(_core.Fade, {
    in: activeMenu >= 0,
    addEndListener: function addEndListener() {}
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    p: 1,
    position: "absolute",
    top: 0,
    right: -60
  }, /*#__PURE__*/_react.default.createElement(_ButtonIcon.default, {
    rounded: true,
    variant: "transparentWhite",
    size: "large",
    icon: "ic_close",
    action: function action() {
      setActiveTab(-1);
      setActiveMenu(-1);
      setOpenDrawerMobileLvl0(false);
      setOpenDrawerMobileLvl1(false);
    }
  })))))), /*#__PURE__*/_react.default.createElement(_core.Slide, {
    direction: "right",
    in: openDrawerMobileLvl2
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    pt: 9,
    position: "fixed",
    width: _AppTheme.default.spacing(42),
    left: 0,
    top: 0,
    bottom: 0,
    bgcolor: "white",
    zIndex: 3,
    boxShadow: "0 2px 8px ".concat((0, _core.fade)(_AppTheme.default.palette.common.black, 0.16))
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    position: "relative",
    className: styles.boxScrollWrap
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    p: 1
  }, /*#__PURE__*/_react.default.createElement(_ButtonIcon.default, {
    rounded: true,
    variant: "transparentGrey",
    size: "large",
    icon: "ic_arrow__left",
    action: function action() {
      setActiveMenu(-1);
      setOpenDrawerMobileLvl2(false);
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    p: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    text: activeMenu > -1 ? menu[activeTab].children[activeMenu].label : ""
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    py: 2,
    className: styles.boxScroll,
    style: {
      marginTop: _AppTheme.default.spacing(10)
    }
  }, activeMenu > -1 && menu[activeTab].children[activeMenu].children.length && /*#__PURE__*/_react.default.createElement(_ListContainer.default, {
    className: styles.listContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    pl: 2,
    pb: 3,
    pt: 0
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    regular: true,
    variant: "h5",
    color: "VfRed",
    text: "See all"
  })), menu[activeTab].children[activeMenu].children.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ListItem.default, _extends({
      primary: item.label,
      align: "center",
      endAdornment: /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
        color: "red",
        icon: "ic_chevron__right",
        size: "xLarge"
      })
    }, normalMenu && item.pageId ? {
      to: item.pageId,
      component: _reactRouterDom.Link
    } : {}, {
      action: function action() {
        setActiveTab(-1);
        setActiveMenu(-1);
        setOpenDrawerMobileLvl0(false);
        setOpenDrawerMobileLvl1(false);
        setOpenDrawerMobileLvl2(false);

        if (item.url) {
          window.open(item.url, "_self");
        } else if (actionMenuItem) {
          actionMenuItem(item);
        }
      }
    })), /*#__PURE__*/_react.default.createElement(_Divider.default, {
      color: "greyTwo"
    }));
  }))), (mobileScreen || !normalMenu) && /*#__PURE__*/_react.default.createElement(_core.Fade, {
    direction: "right",
    in: activeMenu >= 0,
    addEndListener: function addEndListener() {}
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    p: 1,
    position: "absolute",
    top: 0,
    right: -60
  }, /*#__PURE__*/_react.default.createElement(_ButtonIcon.default, {
    rounded: true,
    variant: "transparentWhite",
    size: "large",
    icon: "ic_close",
    action: function action() {
      setActiveTab(-1);
      setActiveMenu(-1);
      setOpenDrawerMobileLvl0(false);
      setOpenDrawerMobileLvl1(false);
      setOpenDrawerMobileLvl2(false);
    }
  }))))))));
};

WebBar.propTypes = {
  menu: _propTypes.default.arrayOf(_propTypes.default.object),
  languageActive: _propTypes.default.string,
  languageMenuItems: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.object])),
  accountMenuItems: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.object])),
  showCart: _propTypes.default.bool,
  showAccount: _propTypes.default.bool,
  showSearch: _propTypes.default.bool,
  showLanguage: _propTypes.default.bool,
  isLogin: _propTypes.default.bool,
  actionMenuItem: _propTypes.default.func,
  onClickLogo: _propTypes.default.func,
  normalMenu: _propTypes.default.bool
};
WebBar.defaultProps = {
  showCart: false,
  showLanguage: false,
  showAccount: false,
  showSearch: false,
  isLogin: false,
  normalMenu: true,
  onClickLogo: function onClickLogo() {}
};
var _default = WebBar;
exports.default = _default;